import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class DomainAddressMailing {
  static fromProto(proto) {
    let m = new DomainAddressMailing();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.address1 !== 'undefined') {
      toReturn['address1'] = this.address1;
    }
    if (typeof this.address2 !== 'undefined') {
      toReturn['address2'] = this.address2;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.postalCode !== 'undefined') {
      toReturn['postalCode'] = this.postalCode;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    return toReturn;
  }
}
class DomainContactAdmin {
  static fromProto(proto) {
    let m = new DomainContactAdmin();
    m = Object.assign(m, proto);
    if (proto.addressMailing) {
      m.addressMailing = DomainAddressMailing.fromProto(proto.addressMailing);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.addressMailing !== 'undefined' && this.addressMailing !== null) {
      toReturn['addressMailing'] = 'toApiJson' in this.addressMailing ? this.addressMailing.toApiJson() : this.addressMailing;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.fax !== 'undefined') {
      toReturn['fax'] = this.fax;
    }
    if (typeof this.jobTitle !== 'undefined') {
      toReturn['jobTitle'] = this.jobTitle;
    }
    if (typeof this.nameFirst !== 'undefined') {
      toReturn['nameFirst'] = this.nameFirst;
    }
    if (typeof this.nameLast !== 'undefined') {
      toReturn['nameLast'] = this.nameLast;
    }
    if (typeof this.nameMiddle !== 'undefined') {
      toReturn['nameMiddle'] = this.nameMiddle;
    }
    if (typeof this.organization !== 'undefined') {
      toReturn['organization'] = this.organization;
    }
    if (typeof this.phone !== 'undefined') {
      toReturn['phone'] = this.phone;
    }
    return toReturn;
  }
}
class DomainContactBilling {
  static fromProto(proto) {
    let m = new DomainContactBilling();
    m = Object.assign(m, proto);
    if (proto.addressMailing) {
      m.addressMailing = DomainAddressMailing.fromProto(proto.addressMailing);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.addressMailing !== 'undefined' && this.addressMailing !== null) {
      toReturn['addressMailing'] = 'toApiJson' in this.addressMailing ? this.addressMailing.toApiJson() : this.addressMailing;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.fax !== 'undefined') {
      toReturn['fax'] = this.fax;
    }
    if (typeof this.jobTitle !== 'undefined') {
      toReturn['jobTitle'] = this.jobTitle;
    }
    if (typeof this.nameFirst !== 'undefined') {
      toReturn['nameFirst'] = this.nameFirst;
    }
    if (typeof this.nameLast !== 'undefined') {
      toReturn['nameLast'] = this.nameLast;
    }
    if (typeof this.nameMiddle !== 'undefined') {
      toReturn['nameMiddle'] = this.nameMiddle;
    }
    if (typeof this.organization !== 'undefined') {
      toReturn['organization'] = this.organization;
    }
    if (typeof this.phone !== 'undefined') {
      toReturn['phone'] = this.phone;
    }
    return toReturn;
  }
}
class DomainContactRegistrant {
  static fromProto(proto) {
    let m = new DomainContactRegistrant();
    m = Object.assign(m, proto);
    if (proto.addressMailing) {
      m.addressMailing = DomainAddressMailing.fromProto(proto.addressMailing);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.addressMailing !== 'undefined' && this.addressMailing !== null) {
      toReturn['addressMailing'] = 'toApiJson' in this.addressMailing ? this.addressMailing.toApiJson() : this.addressMailing;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.fax !== 'undefined') {
      toReturn['fax'] = this.fax;
    }
    if (typeof this.jobTitle !== 'undefined') {
      toReturn['jobTitle'] = this.jobTitle;
    }
    if (typeof this.nameFirst !== 'undefined') {
      toReturn['nameFirst'] = this.nameFirst;
    }
    if (typeof this.nameLast !== 'undefined') {
      toReturn['nameLast'] = this.nameLast;
    }
    if (typeof this.nameMiddle !== 'undefined') {
      toReturn['nameMiddle'] = this.nameMiddle;
    }
    if (typeof this.organization !== 'undefined') {
      toReturn['organization'] = this.organization;
    }
    if (typeof this.phone !== 'undefined') {
      toReturn['phone'] = this.phone;
    }
    return toReturn;
  }
}
class DomainContactTech {
  static fromProto(proto) {
    let m = new DomainContactTech();
    m = Object.assign(m, proto);
    if (proto.addressMailing) {
      m.addressMailing = DomainAddressMailing.fromProto(proto.addressMailing);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.addressMailing !== 'undefined' && this.addressMailing !== null) {
      toReturn['addressMailing'] = 'toApiJson' in this.addressMailing ? this.addressMailing.toApiJson() : this.addressMailing;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.fax !== 'undefined') {
      toReturn['fax'] = this.fax;
    }
    if (typeof this.jobTitle !== 'undefined') {
      toReturn['jobTitle'] = this.jobTitle;
    }
    if (typeof this.nameFirst !== 'undefined') {
      toReturn['nameFirst'] = this.nameFirst;
    }
    if (typeof this.nameLast !== 'undefined') {
      toReturn['nameLast'] = this.nameLast;
    }
    if (typeof this.nameMiddle !== 'undefined') {
      toReturn['nameMiddle'] = this.nameMiddle;
    }
    if (typeof this.organization !== 'undefined') {
      toReturn['organization'] = this.organization;
    }
    if (typeof this.phone !== 'undefined') {
      toReturn['phone'] = this.phone;
    }
    return toReturn;
  }
}
class Domain {
  static fromProto(proto) {
    let m = new Domain();
    m = Object.assign(m, proto);
    if (proto.contactAdmin) {
      m.contactAdmin = DomainContactAdmin.fromProto(proto.contactAdmin);
    }
    if (proto.contactBilling) {
      m.contactBilling = DomainContactBilling.fromProto(proto.contactBilling);
    }
    if (proto.contactRegistrant) {
      m.contactRegistrant = DomainContactRegistrant.fromProto(proto.contactRegistrant);
    }
    if (proto.contactTech) {
      m.contactTech = DomainContactTech.fromProto(proto.contactTech);
    }
    if (proto.createdAt) {
      m.createdAt = new Date(proto.createdAt);
    }
    if (proto.deletedAt) {
      m.deletedAt = new Date(proto.deletedAt);
    }
    if (proto.transferAwayEligibleAt) {
      m.transferAwayEligibleAt = new Date(proto.transferAwayEligibleAt);
    }
    if (proto.domainId) {
      m.domainId = parseInt(proto.domainId, 10);
    }
    if (proto.expires) {
      m.expires = new Date(proto.expires);
    }
    if (proto.renewDeadline) {
      m.renewDeadline = new Date(proto.renewDeadline);
    }
    if (proto.verifications) {
      m.verifications = DomainVerifications.fromProto(proto.verifications);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.authCode !== 'undefined') {
      toReturn['authCode'] = this.authCode;
    }
    if (typeof this.contactAdmin !== 'undefined' && this.contactAdmin !== null) {
      toReturn['contactAdmin'] = 'toApiJson' in this.contactAdmin ? this.contactAdmin.toApiJson() : this.contactAdmin;
    }
    if (typeof this.contactBilling !== 'undefined' && this.contactBilling !== null) {
      toReturn['contactBilling'] = 'toApiJson' in this.contactBilling ? this.contactBilling.toApiJson() : this.contactBilling;
    }
    if (typeof this.contactRegistrant !== 'undefined' && this.contactRegistrant !== null) {
      toReturn['contactRegistrant'] = 'toApiJson' in this.contactRegistrant ? this.contactRegistrant.toApiJson() : this.contactRegistrant;
    }
    if (typeof this.contactTech !== 'undefined' && this.contactTech !== null) {
      toReturn['contactTech'] = 'toApiJson' in this.contactTech ? this.contactTech.toApiJson() : this.contactTech;
    }
    if (typeof this.createdAt !== 'undefined' && this.createdAt !== null) {
      toReturn['createdAt'] = 'toApiJson' in this.createdAt ? this.createdAt.toApiJson() : this.createdAt;
    }
    if (typeof this.deletedAt !== 'undefined' && this.deletedAt !== null) {
      toReturn['deletedAt'] = 'toApiJson' in this.deletedAt ? this.deletedAt.toApiJson() : this.deletedAt;
    }
    if (typeof this.transferAwayEligibleAt !== 'undefined' && this.transferAwayEligibleAt !== null) {
      toReturn['transferAwayEligibleAt'] = 'toApiJson' in this.transferAwayEligibleAt ? this.transferAwayEligibleAt.toApiJson() : this.transferAwayEligibleAt;
    }
    if (typeof this.domain !== 'undefined') {
      toReturn['domain'] = this.domain;
    }
    if (typeof this.domainId !== 'undefined') {
      toReturn['domainId'] = this.domainId;
    }
    if (typeof this.expirationProtected !== 'undefined') {
      toReturn['expirationProtected'] = this.expirationProtected;
    }
    if (typeof this.expires !== 'undefined' && this.expires !== null) {
      toReturn['expires'] = 'toApiJson' in this.expires ? this.expires.toApiJson() : this.expires;
    }
    if (typeof this.exposeWhois !== 'undefined') {
      toReturn['exposeWhois'] = this.exposeWhois;
    }
    if (typeof this.holdRegistrar !== 'undefined') {
      toReturn['holdRegistrar'] = this.holdRegistrar;
    }
    if (typeof this.locked !== 'undefined') {
      toReturn['locked'] = this.locked;
    }
    if (typeof this.nameServers !== 'undefined') {
      toReturn['nameServers'] = this.nameServers;
    }
    if (typeof this.privacy !== 'undefined') {
      toReturn['privacy'] = this.privacy;
    }
    if (typeof this.renewAuto !== 'undefined') {
      toReturn['renewAuto'] = this.renewAuto;
    }
    if (typeof this.renewDeadline !== 'undefined' && this.renewDeadline !== null) {
      toReturn['renewDeadline'] = 'toApiJson' in this.renewDeadline ? this.renewDeadline.toApiJson() : this.renewDeadline;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.subaccountId !== 'undefined') {
      toReturn['subaccountId'] = this.subaccountId;
    }
    if (typeof this.transferProtected !== 'undefined') {
      toReturn['transferProtected'] = this.transferProtected;
    }
    if (typeof this.verifications !== 'undefined' && this.verifications !== null) {
      toReturn['verifications'] = 'toApiJson' in this.verifications ? this.verifications.toApiJson() : this.verifications;
    }
    return toReturn;
  }
}
class DomainDomainName {
  static fromProto(proto) {
    let m = new DomainDomainName();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    return toReturn;
  }
}
class DomainRealName {
  static fromProto(proto) {
    let m = new DomainRealName();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    return toReturn;
  }
}
class DomainVerifications {
  static fromProto(proto) {
    let m = new DomainVerifications();
    m = Object.assign(m, proto);
    if (proto.domainName) {
      m.domainName = DomainDomainName.fromProto(proto.domainName);
    }
    if (proto.realName) {
      m.realName = DomainRealName.fromProto(proto.realName);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.domainName !== 'undefined' && this.domainName !== null) {
      toReturn['domainName'] = 'toApiJson' in this.domainName ? this.domainName.toApiJson() : this.domainName;
    }
    if (typeof this.realName !== 'undefined' && this.realName !== null) {
      toReturn['realName'] = 'toApiJson' in this.realName ? this.realName.toApiJson() : this.realName;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FieldMask {
  static fromProto(proto) {
    let m = new FieldMask();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paths !== 'undefined') {
      toReturn['paths'] = this.paths;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var DNSRecordType = /*#__PURE__*/function (DNSRecordType) {
  DNSRecordType[DNSRecordType["DNS_RECORD_TYPE_ALL"] = 0] = "DNS_RECORD_TYPE_ALL";
  DNSRecordType[DNSRecordType["DNS_RECORD_TYPE_A"] = 1] = "DNS_RECORD_TYPE_A";
  DNSRecordType[DNSRecordType["DNS_RECORD_TYPE_AAAA"] = 2] = "DNS_RECORD_TYPE_AAAA";
  DNSRecordType[DNSRecordType["DNS_RECORD_TYPE_CNAME"] = 3] = "DNS_RECORD_TYPE_CNAME";
  DNSRecordType[DNSRecordType["DNS_RECORD_TYPE_MX"] = 4] = "DNS_RECORD_TYPE_MX";
  DNSRecordType[DNSRecordType["DNS_RECORD_TYPE_NS"] = 5] = "DNS_RECORD_TYPE_NS";
  DNSRecordType[DNSRecordType["DNS_RECORD_TYPE_SOA"] = 6] = "DNS_RECORD_TYPE_SOA";
  DNSRecordType[DNSRecordType["DNS_RECORD_TYPE_SRV"] = 7] = "DNS_RECORD_TYPE_SRV";
  DNSRecordType[DNSRecordType["DNS_RECORD_TYPE_TXT"] = 8] = "DNS_RECORD_TYPE_TXT";
  return DNSRecordType;
}(DNSRecordType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums Index.
// *********************************

function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ContactAddressMailing {
  static fromProto(proto) {
    let m = new ContactAddressMailing();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.address1 !== 'undefined') {
      toReturn['address1'] = this.address1;
    }
    if (typeof this.address2 !== 'undefined') {
      toReturn['address2'] = this.address2;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.postalCode !== 'undefined') {
      toReturn['postalCode'] = this.postalCode;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    return toReturn;
  }
}
class GetDomainAgreementsResponseAgreement {
  static fromProto(proto) {
    let m = new GetDomainAgreementsResponseAgreement();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.agreementKey !== 'undefined') {
      toReturn['agreementKey'] = this.agreementKey;
    }
    if (typeof this.content !== 'undefined') {
      toReturn['content'] = this.content;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    return toReturn;
  }
}
class Contact {
  static fromProto(proto) {
    let m = new Contact();
    m = Object.assign(m, proto);
    if (proto.addressMailing) {
      m.addressMailing = ContactAddressMailing.fromProto(proto.addressMailing);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.addressMailing !== 'undefined' && this.addressMailing !== null) {
      toReturn['addressMailing'] = 'toApiJson' in this.addressMailing ? this.addressMailing.toApiJson() : this.addressMailing;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.fax !== 'undefined') {
      toReturn['fax'] = this.fax;
    }
    if (typeof this.jobTitle !== 'undefined') {
      toReturn['jobTitle'] = this.jobTitle;
    }
    if (typeof this.nameFirst !== 'undefined') {
      toReturn['nameFirst'] = this.nameFirst;
    }
    if (typeof this.nameLast !== 'undefined') {
      toReturn['nameLast'] = this.nameLast;
    }
    if (typeof this.nameMiddle !== 'undefined') {
      toReturn['nameMiddle'] = this.nameMiddle;
    }
    if (typeof this.organization !== 'undefined') {
      toReturn['organization'] = this.organization;
    }
    if (typeof this.phone !== 'undefined') {
      toReturn['phone'] = this.phone;
    }
    return toReturn;
  }
}
class DNSRecord {
  static fromProto(proto) {
    let m = new DNSRecord();
    m = Object.assign(m, proto);
    if (proto.ttl) {
      m.ttl = parseInt(proto.ttl, 10);
    }
    if (proto.priority) {
      m.priority = parseInt(proto.priority, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.data !== 'undefined') {
      toReturn['data'] = this.data;
    }
    if (typeof this.ttl !== 'undefined') {
      toReturn['ttl'] = this.ttl;
    }
    if (typeof this.priority !== 'undefined') {
      toReturn['priority'] = this.priority;
    }
    return toReturn;
  }
}
class DeleteDNSRecordRequest {
  static fromProto(proto) {
    let m = new DeleteDNSRecordRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.domain !== 'undefined') {
      toReturn['domain'] = this.domain;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class ValidateDomainContactResponseField {
  static fromProto(proto) {
    let m = new ValidateDomainContactResponseField();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.message !== 'undefined') {
      toReturn['message'] = this.message;
    }
    if (typeof this.path !== 'undefined') {
      toReturn['path'] = this.path;
    }
    return toReturn;
  }
}
class GetDomainAgreementsRequest {
  static fromProto(proto) {
    let m = new GetDomainAgreementsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.tlds !== 'undefined') {
      toReturn['tlds'] = this.tlds;
    }
    if (typeof this.privacy !== 'undefined') {
      toReturn['privacy'] = this.privacy;
    }
    return toReturn;
  }
}
class GetDomainAgreementsResponse {
  static fromProto(proto) {
    let m = new GetDomainAgreementsResponse();
    m = Object.assign(m, proto);
    if (proto.agreements) {
      m.agreements = proto.agreements.map(GetDomainAgreementsResponseAgreement.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.agreements !== 'undefined' && this.agreements !== null) {
      toReturn['agreements'] = 'toApiJson' in this.agreements ? this.agreements.toApiJson() : this.agreements;
    }
    return toReturn;
  }
}
class GetDomainAvailableRequest {
  static fromProto(proto) {
    let m = new GetDomainAvailableRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.domain !== 'undefined') {
      toReturn['domain'] = this.domain;
    }
    return toReturn;
  }
}
class GetDomainAvailableResponse {
  static fromProto(proto) {
    let m = new GetDomainAvailableResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.available !== 'undefined') {
      toReturn['available'] = this.available;
    }
    return toReturn;
  }
}
class GetDomainRequest {
  static fromProto(proto) {
    let m = new GetDomainRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.domain !== 'undefined') {
      toReturn['domain'] = this.domain;
    }
    return toReturn;
  }
}
class GetDomainResponse {
  static fromProto(proto) {
    let m = new GetDomainResponse();
    m = Object.assign(m, proto);
    if (proto.domain) {
      m.domain = Domain.fromProto(proto.domain);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.domain !== 'undefined' && this.domain !== null) {
      toReturn['domain'] = 'toApiJson' in this.domain ? this.domain.toApiJson() : this.domain;
    }
    return toReturn;
  }
}
class GetDomainSuggestionAndPriceRequest {
  static fromProto(proto) {
    let m = new GetDomainSuggestionAndPriceRequest();
    m = Object.assign(m, proto);
    if (proto.limit) {
      m.limit = parseInt(proto.limit, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.domain !== 'undefined') {
      toReturn['domain'] = this.domain;
    }
    if (typeof this.tlds !== 'undefined') {
      toReturn['tlds'] = this.tlds;
    }
    if (typeof this.limit !== 'undefined') {
      toReturn['limit'] = this.limit;
    }
    return toReturn;
  }
}
class GetDomainSuggestionAndPriceResponse {
  static fromProto(proto) {
    let m = new GetDomainSuggestionAndPriceResponse();
    m = Object.assign(m, proto);
    if (proto.suggestions) {
      m.suggestions = proto.suggestions.map(GetDomainSuggestionAndPriceResponseSuggestion.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.suggestions !== 'undefined' && this.suggestions !== null) {
      toReturn['suggestions'] = 'toApiJson' in this.suggestions ? this.suggestions.toApiJson() : this.suggestions;
    }
    return toReturn;
  }
}
class ListDNSRecordsRequest {
  static fromProto(proto) {
    let m = new ListDNSRecordsRequest();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue(DNSRecordType, proto.type);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.domain !== 'undefined') {
      toReturn['domain'] = this.domain;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    return toReturn;
  }
}
class ListDNSRecordsResponse {
  static fromProto(proto) {
    let m = new ListDNSRecordsResponse();
    m = Object.assign(m, proto);
    if (proto.dnsRecords) {
      m.dnsRecords = proto.dnsRecords.map(DNSRecord.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.dnsRecords !== 'undefined' && this.dnsRecords !== null) {
      toReturn['dnsRecords'] = 'toApiJson' in this.dnsRecords ? this.dnsRecords.toApiJson() : this.dnsRecords;
    }
    return toReturn;
  }
}
class ListDomainsByBusinessIDRequest {
  static fromProto(proto) {
    let m = new ListDomainsByBusinessIDRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class ListDomainsByBusinessIDResponse {
  static fromProto(proto) {
    let m = new ListDomainsByBusinessIDResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.domains !== 'undefined') {
      toReturn['domains'] = this.domains;
    }
    return toReturn;
  }
}
class PatchDomainRequest {
  static fromProto(proto) {
    let m = new PatchDomainRequest();
    m = Object.assign(m, proto);
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.domain !== 'undefined') {
      toReturn['domain'] = this.domain;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    if (typeof this.locked !== 'undefined') {
      toReturn['locked'] = this.locked;
    }
    return toReturn;
  }
}
class PutDNSRecordRequest {
  static fromProto(proto) {
    let m = new PutDNSRecordRequest();
    m = Object.assign(m, proto);
    if (proto.dnsRecord) {
      m.dnsRecord = DNSRecord.fromProto(proto.dnsRecord);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.domain !== 'undefined') {
      toReturn['domain'] = this.domain;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.dnsRecord !== 'undefined' && this.dnsRecord !== null) {
      toReturn['dnsRecord'] = 'toApiJson' in this.dnsRecord ? this.dnsRecord.toApiJson() : this.dnsRecord;
    }
    return toReturn;
  }
}
class RenewDomainRequest {
  static fromProto(proto) {
    let m = new RenewDomainRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.domain !== 'undefined') {
      toReturn['domain'] = this.domain;
    }
    return toReturn;
  }
}
class RenewDomainResponse {
  static fromProto(proto) {
    let m = new RenewDomainResponse();
    m = Object.assign(m, proto);
    if (proto.itemCount) {
      m.itemCount = parseInt(proto.itemCount, 10);
    }
    if (proto.orderId) {
      m.orderId = parseInt(proto.orderId, 10);
    }
    if (proto.total) {
      m.total = parseInt(proto.total, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.currency !== 'undefined') {
      toReturn['currency'] = this.currency;
    }
    if (typeof this.itemCount !== 'undefined') {
      toReturn['itemCount'] = this.itemCount;
    }
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.total !== 'undefined') {
      toReturn['total'] = this.total;
    }
    return toReturn;
  }
}
class ReplaceAllDNSRecordsRequest {
  static fromProto(proto) {
    let m = new ReplaceAllDNSRecordsRequest();
    m = Object.assign(m, proto);
    if (proto.dnsRecords) {
      m.dnsRecords = proto.dnsRecords.map(DNSRecord.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.domain !== 'undefined') {
      toReturn['domain'] = this.domain;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.dnsRecords !== 'undefined' && this.dnsRecords !== null) {
      toReturn['dnsRecords'] = 'toApiJson' in this.dnsRecords ? this.dnsRecords.toApiJson() : this.dnsRecords;
    }
    return toReturn;
  }
}
class ReplaceDNSRecordsForTypeRequest {
  static fromProto(proto) {
    let m = new ReplaceDNSRecordsForTypeRequest();
    m = Object.assign(m, proto);
    if (proto.dnsRecords) {
      m.dnsRecords = proto.dnsRecords.map(DNSRecord.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.domain !== 'undefined') {
      toReturn['domain'] = this.domain;
    }
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.dnsRecords !== 'undefined' && this.dnsRecords !== null) {
      toReturn['dnsRecords'] = 'toApiJson' in this.dnsRecords ? this.dnsRecords.toApiJson() : this.dnsRecords;
    }
    return toReturn;
  }
}
class GetDomainSuggestionAndPriceResponseSuggestion {
  static fromProto(proto) {
    let m = new GetDomainSuggestionAndPriceResponseSuggestion();
    m = Object.assign(m, proto);
    if (proto.price) {
      m.price = parseInt(proto.price, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.domain !== 'undefined') {
      toReturn['domain'] = this.domain;
    }
    if (typeof this.price !== 'undefined') {
      toReturn['price'] = this.price;
    }
    return toReturn;
  }
}
class ValidateDomainContactRequest {
  static fromProto(proto) {
    let m = new ValidateDomainContactRequest();
    m = Object.assign(m, proto);
    if (proto.contactAdmin) {
      m.contactAdmin = Contact.fromProto(proto.contactAdmin);
    }
    if (proto.contactRegistrant) {
      m.contactRegistrant = Contact.fromProto(proto.contactRegistrant);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.contactAdmin !== 'undefined' && this.contactAdmin !== null) {
      toReturn['contactAdmin'] = 'toApiJson' in this.contactAdmin ? this.contactAdmin.toApiJson() : this.contactAdmin;
    }
    if (typeof this.contactRegistrant !== 'undefined' && this.contactRegistrant !== null) {
      toReturn['contactRegistrant'] = 'toApiJson' in this.contactRegistrant ? this.contactRegistrant.toApiJson() : this.contactRegistrant;
    }
    if (typeof this.domains !== 'undefined') {
      toReturn['domains'] = this.domains;
    }
    return toReturn;
  }
}
class ValidateDomainContactResponse {
  static fromProto(proto) {
    let m = new ValidateDomainContactResponse();
    m = Object.assign(m, proto);
    if (proto.fields) {
      m.fields = proto.fields.map(ValidateDomainContactResponseField.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fields !== 'undefined' && this.fields !== null) {
      toReturn['fields'] = 'toApiJson' in this.fields ? this.fields.toApiJson() : this.fields;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'godaddy-api.vendasta-local.com',
  'test': '',
  'demo': 'godaddy-api-demo.apigateway.co',
  'prod': 'godaddy-api-prod.apigateway.co',
  'production': 'godaddy-api-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(t) {
    return new (t || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let GoDaddyApiService = /*#__PURE__*/(() => {
  class GoDaddyApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getDomainSuggestionAndPrice(r) {
      const request = r.toApiJson ? r : new GetDomainSuggestionAndPriceRequest(r);
      return this.http.post(this._host + "/godaddy.v1.GoDaddy/GetDomainSuggestionAndPrice", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetDomainSuggestionAndPriceResponse.fromProto(resp)));
    }
    listDnsRecords(r) {
      const request = r.toApiJson ? r : new ListDNSRecordsRequest(r);
      return this.http.post(this._host + "/godaddy.v1.GoDaddy/ListDNSRecords", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListDNSRecordsResponse.fromProto(resp)));
    }
    putDnsRecord(r) {
      const request = r.toApiJson ? r : new PutDNSRecordRequest(r);
      return this.http.post(this._host + "/godaddy.v1.GoDaddy/PutDNSRecord", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    replaceDnsRecordsForType(r) {
      const request = r.toApiJson ? r : new ReplaceDNSRecordsForTypeRequest(r);
      return this.http.post(this._host + "/godaddy.v1.GoDaddy/ReplaceDNSRecordsForType", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    replaceAllDnsRecords(r) {
      const request = r.toApiJson ? r : new ReplaceAllDNSRecordsRequest(r);
      return this.http.post(this._host + "/godaddy.v1.GoDaddy/ReplaceAllDNSRecords", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteDnsRecord(r) {
      const request = r.toApiJson ? r : new DeleteDNSRecordRequest(r);
      return this.http.post(this._host + "/godaddy.v1.GoDaddy/DeleteDNSRecord", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getDomainAvailable(r) {
      const request = r.toApiJson ? r : new GetDomainAvailableRequest(r);
      return this.http.post(this._host + "/godaddy.v1.GoDaddy/GetDomainAvailable", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetDomainAvailableResponse.fromProto(resp)));
    }
    getDomainAgreements(r) {
      const request = r.toApiJson ? r : new GetDomainAgreementsRequest(r);
      return this.http.post(this._host + "/godaddy.v1.GoDaddy/GetDomainAgreements", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetDomainAgreementsResponse.fromProto(resp)));
    }
    validateDomainContact(r) {
      const request = r.toApiJson ? r : new ValidateDomainContactRequest(r);
      return this.http.post(this._host + "/godaddy.v1.GoDaddy/ValidateDomainContact", request.toApiJson(), this.apiOptions()).pipe(map(resp => ValidateDomainContactResponse.fromProto(resp)));
    }
    listDomainsByBusinessId(r) {
      const request = r.toApiJson ? r : new ListDomainsByBusinessIDRequest(r);
      return this.http.post(this._host + "/godaddy.v1.GoDaddy/ListDomainsByBusinessID", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListDomainsByBusinessIDResponse.fromProto(resp)));
    }
    patchDomain(r) {
      const request = r.toApiJson ? r : new PatchDomainRequest(r);
      return this.http.post(this._host + "/godaddy.v1.GoDaddy/PatchDomain", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getDomain(r) {
      const request = r.toApiJson ? r : new GetDomainRequest(r);
      return this.http.post(this._host + "/godaddy.v1.GoDaddy/GetDomain", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetDomainResponse.fromProto(resp)));
    }
    renewDomain(r) {
      const request = r.toApiJson ? r : new RenewDomainRequest(r);
      return this.http.post(this._host + "/godaddy.v1.GoDaddy/RenewDomain", request.toApiJson(), this.apiOptions()).pipe(map(resp => RenewDomainResponse.fromProto(resp)));
    }
  }
  GoDaddyApiService.ɵfac = function GoDaddyApiService_Factory(t) {
    return new (t || GoDaddyApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  GoDaddyApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: GoDaddyApiService,
    factory: GoDaddyApiService.ɵfac,
    providedIn: 'root'
  });
  return GoDaddyApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let GoDaddyService = /*#__PURE__*/(() => {
  class GoDaddyService {
    constructor(goDaddyApiService) {
      this.goDaddyApiService = goDaddyApiService;
    }
    getDomainSuggestionAndPrice(domain, tlds, limit) {
      return this.goDaddyApiService.getDomainSuggestionAndPrice(new GetDomainSuggestionAndPriceRequest({
        domain: domain,
        tlds: tlds,
        limit: limit
      })).pipe(map(resp => {
        return resp.suggestions;
      }));
    }
    listDnsRecords(domain, partnerId, type) {
      return this.goDaddyApiService.listDnsRecords(new ListDNSRecordsRequest({
        domain: domain,
        partnerId: partnerId,
        type: type
      })).pipe(map(resp => {
        return resp.dnsRecords;
      }));
    }
    putDnsRecord(domain, partnerId, dnsRecord) {
      return this.goDaddyApiService.putDnsRecord(new PutDNSRecordRequest({
        domain: domain,
        partnerId: partnerId,
        dnsRecord: dnsRecord
      })).pipe(map(() => true));
    }
    replaceDnsRecordsForType(domain, type, dnsRecords) {
      return this.goDaddyApiService.replaceDnsRecordsForType(new ReplaceDNSRecordsForTypeRequest({
        domain: domain,
        type: type,
        dnsRecords: dnsRecords
      })).pipe(map(() => true));
    }
    replaceAllDnsRecords(domain, partnerId, dnsRecords) {
      return this.goDaddyApiService.replaceAllDnsRecords(new ReplaceAllDNSRecordsRequest({
        domain: domain,
        partnerId: partnerId,
        dnsRecords: dnsRecords
      })).pipe(map(() => true));
    }
    deleteDnsRecord(domain, type, name, partnerId) {
      return this.goDaddyApiService.deleteDnsRecord(new DeleteDNSRecordRequest({
        domain: domain,
        type: type,
        name: name,
        partnerId: partnerId
      })).pipe(map(() => true));
    }
    getDomainAvailable(domain) {
      return this.goDaddyApiService.getDomainAvailable(new GetDomainAvailableRequest({
        domain: domain
      })).pipe(map(resp => {
        return resp.available;
      }));
    }
    getDomainAgreements(tlds, privacy) {
      return this.goDaddyApiService.getDomainAgreements(new GetDomainAgreementsRequest({
        tlds: tlds,
        privacy: privacy
      })).pipe(map(resp => {
        return resp.agreements;
      }));
    }
    validateDomainContact(contactAdmin, contactRegistrant, domains) {
      return this.goDaddyApiService.validateDomainContact(new ValidateDomainContactRequest({
        contactAdmin: contactAdmin,
        contactRegistrant: contactRegistrant,
        domains: domains
      })).pipe(map(resp => {
        return resp.fields;
      }));
    }
    listDomainsByBusinessId(businessId) {
      return this.goDaddyApiService.listDomainsByBusinessId(new ListDomainsByBusinessIDRequest({
        businessId: businessId
      })).pipe(map(resp => {
        return resp.domains;
      }));
    }
    renewDomain(domain) {
      return this.goDaddyApiService.renewDomain(new RenewDomainRequest({
        domain: domain
      }));
    }
  }
  GoDaddyService.ɵfac = function GoDaddyService_Factory(t) {
    return new (t || GoDaddyService)(i0.ɵɵinject(GoDaddyApiService));
  };
  GoDaddyService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: GoDaddyService,
    factory: GoDaddyService.ɵfac,
    providedIn: 'root'
  });
  return GoDaddyService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************

/**
 * Generated bundle index. Do not edit.
 */

export { Contact, ContactAddressMailing, DNSRecord, DNSRecordType, DeleteDNSRecordRequest, Domain, DomainAddressMailing, DomainContactAdmin, DomainContactBilling, DomainContactRegistrant, DomainContactTech, DomainDomainName, DomainRealName, DomainVerifications, FieldMask, GetDomainAgreementsRequest, GetDomainAgreementsResponse, GetDomainAgreementsResponseAgreement, GetDomainAvailableRequest, GetDomainAvailableResponse, GetDomainRequest, GetDomainResponse, GetDomainSuggestionAndPriceRequest, GetDomainSuggestionAndPriceResponse, GetDomainSuggestionAndPriceResponseSuggestion, GoDaddyApiService, GoDaddyService, HostService, ListDNSRecordsRequest, ListDNSRecordsResponse, ListDomainsByBusinessIDRequest, ListDomainsByBusinessIDResponse, PatchDomainRequest, PutDNSRecordRequest, RenewDomainRequest, RenewDomainResponse, ReplaceAllDNSRecordsRequest, ReplaceDNSRecordsForTypeRequest, ValidateDomainContactRequest, ValidateDomainContactResponse, ValidateDomainContactResponseField };
